import React from 'react';
import styles from './Pagination.module.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // 페이지 범위 계산 (최대 5개 페이지 표시)
  const getPageRange = () => {
    const range = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, startPage + 4);
    
    for (let i = startPage; i <= endPage; i++) {
      range.push(i);
    }
    
    return range;
  };

  return (
    <div className={styles.pagination}>
      {/* 첫 페이지 버튼 */}
      <button
        className={styles.pageButton}
        disabled={currentPage === 1}
        onClick={() => onPageChange(1)}
      >
        &laquo;
      </button>
      
      {/* 이전 페이지 버튼 */}
      <button
        className={styles.pageButton}
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        &lsaquo;
      </button>
      
      {/* 페이지 번호 */}
      {getPageRange().map(page => (
        <button
          key={page}
          className={`${styles.pageButton} ${page === currentPage ? styles.active : ''}`}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ))}
      
      {/* 다음 페이지 버튼 */}
      <button
        className={styles.pageButton}
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        &rsaquo;
      </button>
      
      {/* 마지막 페이지 버튼 */}
      <button
        className={styles.pageButton}
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(totalPages)}
      >
        &raquo;
      </button>
    </div>
  );
};

export default Pagination;